import type { FeatureFlag } from '@ps/web-core-enums';

import type { RootState, SelectorCreator, Slicer } from '../../types';

import type { FeatureState } from './feature';

const selectors = (slice: Slicer<FeatureState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  check() {
    return createSelector(
      slice,
      (rootState: RootState, feature: string) => feature,
      (state, feature) => {
        const featureFlag = feature as FeatureFlag;
        return !!state[featureFlag];
      }
    );
  },
  list() {
    return slice((state) => Object.keys(state) as FeatureFlag[]);
  }
});

export default selectors;
